'use client';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Typography } from '@mui/material';

import { PALETTE_KEYS } from '@/constants/theme.constants';

interface WithdrawalErrorProps {
  error: string;
  onReset: () => void;
}

export const WithdrawalError = ({ error, onReset }: WithdrawalErrorProps) => (
  <Box
    sx={{
      p: 2,
      mb: 4,
      bgcolor: 'error.bg',
      border: '1px solid',
      borderColor: 'error.border',
      borderRadius: 2,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      <ErrorOutlineIcon sx={{ color: PALETTE_KEYS.ERROR_MAIN, mr: 1 }} fontSize="small" />
      <Typography variant="body2" color={PALETTE_KEYS.ERROR_MAIN} fontWeight={600}>
        Transfer Error
      </Typography>
    </Box>
    <Typography variant="body2" color={PALETTE_KEYS.ERROR_MAIN}>
      {error}
    </Typography>
    <Button
      size="small"
      onClick={onReset}
      sx={{ mt: 1, textTransform: 'none', color: PALETTE_KEYS.TEXT_PRIMARY }}
    >
      Try again
    </Button>
  </Box>
);
